import type { UseDateTimeTextFormatterArgs } from '../../hooks';
import { useDateTimeTextFormatter } from '../../hooks';

export interface DateTimeTextProps extends UseDateTimeTextFormatterArgs {
  date: number | string | Date;
}

export function DateTimeText({ date, ...props }: DateTimeTextProps) {
  const dateFormatter = useDateTimeTextFormatter({ showTime: true, ...props });
  return <span>{dateFormatter.format(new Date(date))}</span>;
}
